import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  Output,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { IDynamicTableColumn, IPagination } from '@app/shared/interfaces/index';

@Component({
  selector: 'app-dynamic-table',
  templateUrl: './dynamic-table.component.html',
  styleUrls: ['./dynamic-table.component.sass'],
})
export class DynamicTableComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() data: any[] = [];
  @Input() columns: IDynamicTableColumn[] = [];
  @Input() pagination: IPagination;
  @Output() pageChange = new EventEmitter<any>();
  @Output() actionEvent = new EventEmitter<{ action: string; row: any }>();
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @Input() bare: boolean = false;
  displayedColumns: string[] = [];
  @Input() serverSide: boolean = false;
  dataSource: MatTableDataSource<any>;
  actionColumn: IDynamicTableColumn;
  serverPagination: IPagination;

  ngOnInit(): void {
    const enableActions = ['isLink', 'tools'];

    this.displayedColumns = this.columns.map((c) => c.columnDef);
    this.actionColumn = this.columns.find((c) => enableActions.includes(c.columnDef));
    if (this.actionColumn) {
      this.displayedColumns = this.displayedColumns.filter((c) => !enableActions.includes(c));
      this.displayedColumns.push('actions');
    }
    this.dataSource = new MatTableDataSource(this.data);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      this.dataSource = new MatTableDataSource(this.data);
      this.serverPagination = this.pagination;
    }
  }

  ngAfterViewInit() {
    if (this.pagination) {
      if (!this.serverSide) {
        this.dataSource.paginator = this.paginator;
      }
      this.serverPagination = this.pagination;
    }
  }

  onAction(action: string, row: any) {
    this.actionEvent.emit({ action, row });
  }

  getWarningTooltip(column: IDynamicTableColumn, element: any): string {
    const tooltip = column.warningIcon?.tooltip;
    return typeof tooltip === 'function' ? tooltip(element) : tooltip ?? '';
  }

  onPageChange(event: any) {
    this.pageChange.emit({
      currentPage: event.pageIndex + 1,
      pageSize: event.pageSize,
    });
  }
}
